import { render } from "./Okved.vue?vue&type=template&id=71b0905e"
import script from "./Okved.vue?vue&type=script&lang=js"
export * from "./Okved.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__